module.exports = __webpack_public_path__ + "static/media/ic_server_on.d9508ea7.svg";